export default {
  header: {
    title: '💛 Anna tippi tiimille',
    subtitle: '100 % menee henkilökunnalle',
  },
  buttons: {
    other: 'Muu',
    none: 'Ei mitään',
  },
  summary_label: 'Tippi',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} on suurin sallittu tippi',
      },
    },
  },
};
